<template>
  <div class="w-full enervon-active">
    <div class="w-full flex justify-center lg:py-[150px] bg-[url('/img/enervon_active/bg-main-banner.webp')] bg-cover bg-no-repeat bg-center top-banner" v-if="getPageData('intro').length > 0" id="mainbanner-section">
          <div class="container flex justify-center">
              <div class="row justify-center">
                  <div class="row col-sm-6 col-lg-5 content-center">
              <img class="w-[350px] h-[350px]" src="/img/enervon_active/ProdukWeb.webp" width="350" height="350" alt="kandungan enervon active">
          </div>

          <div class="col-sm-6 col-lg-5 self-center py-2">
            <div class="text-header title-top-container">
              <h1 class="leading-tight full-visible desc-1 font-bold !text-[20px] md:!text-[30px] text-white">BERSTAMINA DENGAN <br/> ENERVON ACTIVE</h1>
              <div class="leading-tight full-visible desc-1 font-bold !text-[15px] md:!text-[20px] text-white" v-html="getPageData('intro')[0].txt_content">
              </div>
              <!-- <div class="fadeInUp-animation">
								<button class="fadeInUp-animation bg-transparent pt-[12px] px-[40px] pb-[10px] text-white hover:text-yellow-600 hover:bg-white-500 font-bold py-2 px-4 hover:bg-white border border-white-500 hover:border-white-500 font-bold text-sm" @click="scrollToSection('where-to-buy')">
								BUY NOW
								</button>
							</div> -->
            </div>                    
          </div>
        </div>
      </div>
    </div>

    <section class="pt-[60px] min-[991px]:pt-[90px] pb-[40px] bg-[url('/img/enervon_c/bg-slide2.webp')] bg-center bg-no-repeat bg-fixed" v-if="getPageData('why').length > 0">
        <div class="container mx-auto">
          <div class="flex flex-col-reverse w-full md:flex-row">
            <div class="flex flex-col md:w-8/12 md:pr-[60px]">
              <h2 class="!text-[28px] md:!text-[40px] font-[600] mb-[40px]">{{getPageData('why')[0].vch_name}}</h2>
              <div class="flex flex-col">
                <div class="accordion delay default-list" id="accordion-why-enervon-c">
                  <div v-for="(item, index) in getPageData('why')[0].content">
                    <div class="w-full mb-[20px] max-w-none overflow-hidden bg-transparent py-0 text-black transition-all duration-300 border border-x-transparent border-t-transparent border-b-gray-300">
                        <input :id="'toggle-' + index"  class="peer/showLabel absolute scale-0 toogle" type="checkbox"/>
                        <label :for="'toggle-' + index" class="colappse-dropdown pb-[20px] flex cursor-pointer items-center font-bold font-bold text-[20px] flex items-center justify-between w-full">
                              {{item.name}}
                            <span class="w-2 h-2 mx-2">
                              <svg
                                class="text-orange-500 content-center rotate-0"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 8 14"
                              >
                                <path
                                  stroke="currentColor"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"
                                />
                              </svg>
                            </span>
                        </label>
                        <div class="max-h-0 font-serif text-[#666] peer-checked/showLabel:max-h-none  peer-checked/showLabel:pb-[30px]" v-html="item.description">
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              
            </div>
            <div class="flex md:w-4/12 justify-center">
              <div class="relative w-[250px] h-[250px]">
                <img
                  data-src="/img/enervon_active/moon.webp" 
                  src="/img/noimage.gif"
                  alt="enervon active"
                  class="w-full hilang muncul full-visible lazy w-[250px] h-[250px] fadeInUp-animation"
                  loading="lazy"
                />
                <img
                  data-src="/img/enervon_active/pill-1.webp" 
                  src="/img/noimage.gif"
                  alt="enervon active"
                  class="absolute top-0 left-[-40px] hilang muncul full-visible lazy w-[110px] h-auto fadeInUp-animation"
                  loading="lazy"
                />
                <img
                  data-src="/img/enervon_active/pill-2.webp" 
                  src="/img/noimage.gif"
                  alt="enervon active"
                  class="absolute bottom-[0px] right-[0px] hilang muncul full-visible lazy w-[110px] h-auto fadeInUp-animation"
                  loading="lazy"
                />
                <img
                  data-src="/img/enervon_active/pill-3.webp" 
                  src="/img/noimage.gif"
                  alt="enervon active"
                  class="absolute m-auto left-0 right-0 top-0 bottom-0 w-full hilang muncul full-visible lazy w-[250px] h-[176px] fadeInUp-animation"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

     <section class="banner-6th bg-[url('/img/enervon_active/bg-slide3.webp')] bg-cover bg-center bg-no-repeat py-[50px]" id="product1a-section"  v-if="getPageData('more').length > 0">
          <div class="container">
              <div class="row justify-center">
                  <div class="col-md-6 col-lg-6"><img data-src="/img/enervon_active/botol-active.webp" src="/img/noimage.gif" alt="enervon active" class="fadeInRight-animation full-visible lazy"></div>
                  <div class="col-md-6 col-lg-5 title-section self-center">
                      <div class="title-section-agar banner-container delay">
                        <div class="title-banner-6th fadeInUp-animation full-visible text-[46px] text-white font-[600] mb-4" v-html="getPageData('more')[0].vch_name"></div>
                        <div class="fadeInUp full-visible text-[20px] font-serif text-white font-[500]" v-html="getPageData('more')[0].txt_content"></div>
                      </div>
                  </div>
              </div>
          </div>
      </section>

    
      <section class="section-style banner-4th pt-[90px] bg-[url('/img/enervon_c/bg_city.webp')] bg-fixed bg-no-repeat bg-center" id="wheretobuy">
            <div class="banner-enervonc-set title-section container">
                <h2 class="banner-title-2nd text-center fadeInUp-animation fadeInUpBig full-visible mb-[60px]">Dapatkan Enervon Active di sini</h2> 
                <img class="fadeInUp-animation mb-[-310px] lazy" data-src="/img/enervon_active/product_4.webp" src="/img/noimage.gif" alt="enervon active">				
            </div>
        </section>

        <section class="section-style banner-5th bg-[#ffe6d5] pt-[15em] pb-[10px]" id="where-to-buy" v-if="getPageData('where').length > 0">
        <div class="container" id="gotostore">
          <div class="olshop-list-container delay">
            <div class="row justify-center mb-[30px] fadeInUp-animation" v-for="(item) in getPageData('where')[0].content">
              <div class="col-6 col-sm-4">
                <a :href="item.link" target="_blank">
                  <img :data-src="`/${item.image}`" :alt="`Enervon Active on ${item.name}`" src="/img/noimage.gif" style="max-width: 100%;" class="lazy">
                </a>
              </div>
            </div>
          </div>
          <div class="offlineshop-list delay mt-[60px]">
            <div class="row justify-center">
              <div class="col0-sm-10 col-lg-6 delay">
                <hr class="fadeInUp-animation border-t-[2px] border-solid border-t-[#999] py-[20px]">
                <div class="fadeInUp-animation full-visible">
                  <h3 class="text-center text-[1.4em] font-bold mb-[30px]">Atau temukan produk Enervon Active <br> di toko-toko terdekat</h3>
                </div>
              </div>
            </div>
            <div class="fadeInUp-animation">
              <ul class="flex flex-wrap justify-center">
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-indomaret.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-alfamidi.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-alfamart.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-watsons.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-guardian.png" alt="enervon active"> </li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-century.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-boston.png" alt="enervon active"></li>
              </ul>
              <ul class="flex flex-wrap justify-center">
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-carrefour.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-hypermart.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-giant.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-yogya.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-ranchmarket.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-foodhall.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-foodmart.png" alt="enervon active"></li>
              </ul>
              <ul class="flex flex-wrap justify-center">
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-naga.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-harihari.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-hero.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-lotte.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-superindo.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-circlek.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-lawson.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-lulu.png" alt="enervon active"></li>
                <li class="inline-flex"><img class="lazy" src="/img/noimage.gif" data-src="/img/sm-logo-tiptop.png" alt="enervon active"></li>
              </ul>
            </div>
          </div>
          <div class="mt-10 justify-center flex text-[12px] sm:text-[14px]">
            Diproduksi oleh:&nbsp;<span class="font-bold">PT Mediafarma Labotaries</span>
          </div>
        </div>
      </section>
  </div>

</template>
<script setup lang="ts">
  import {reactive, onMounted, onBeforeUnmount, ref, nextTick} from "vue"
  import LazyLoad from "vanilla-lazyload"

    const props = defineProps({
      sharedHeaderClass: String
    })

    const gotostore = useState('gotostore')
    const first_collapse = ref(true)
    const second_collapse = ref(true)
    let lazyLoadInstance

    const websiteConfig = useState('websiteConfig');
    const route = useRoute()
    const url = useRequestURL()

    gotostore.value = '/enervonactive#gotostore'

    const page = websiteConfig.value.pages.filter((item) => {
        return item.vch_slug == route.name
    })

    if(page.length == 0){
        throw createError({
            statusCode: 404,
            statusMessage: 'Page Not Found'
        })
    }

    let slug = reactive({data: {}})

    const slugApi = ssrContent({
      path: '/api/menu-detail',
      method: 'POST',
      body: {
        category_slug: route.name
      }
    })

    const emit = defineEmits(['updateSharedHeaderClass'])

    const { data , error} = await useAsyncData(async () => {
      const [slugData] = await Promise.all([
        slugApi.loadApi()
      ])

      return {slugData}
    })

    if(error.value !== null)
      console.log(error.value)

    slug.data = data.value.slugData.data

    onMounted(() => {
      setHeader()

      lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy"
      })

      window.addEventListener('scroll', setHeader)
      window.addEventListener('resize', setHeader)
    })

    onBeforeUnmount(() => {
        emit('updateSharedHeaderClass', '')
        window.removeEventListener('scroll', setHeader)
        window.addEventListener('resize', setHeader)
    })

    const setHeader = () => {
      if(document.documentElement["clientWidth"] >= 1024){
          if(window.pageYOffset > 100){
            emit('updateSharedHeaderClass', '')
          }else{
            emit('updateSharedHeaderClass', 'transparent-header enervonactive')
          }
      }else{
          emit('updateSharedHeaderClass', '')
      }
    }

    const getPageData = (vch_slug) => {
      const data = slug.data.widgets.filter((item) => {
          return item.vch_slug == vch_slug
      })
      
      return data
    }

    const scrollToSection = (id) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };

    useHead({
      title: 'ENERVON ACTIVE - Multivitamin dan Mineral Agar Tubuh Tetap Aktif',
      link: [
        { rel: 'image_src', href: `${url.origin}/img/enervon_active/botol-active.webp` },
        { rel: 'canonical', href: `${url.origin}/enervonactive` },
        { rel: 'preload', as: 'image', type: 'image/webp', href: `/img/enervon_active/ProdukWeb.webp`, fetchpriority: "high"},
      ],
      meta: [
        { name: 'description', content: 'Enervon Active adalah Multivitamin dan Mineral dengan kandungan ENERZINC untuk menjaga tubuh biar ga gampang lelah dan terus aktif!' },
        { name: 'og:title', content: 'ENERVON ACTIVE - Multivitamin dan Mineral Agar Tubuh Tetap Aktif' },
        { name: 'og:description', content: 'Enervon Active adalah Multivitamin dan Mineral dengan kandungan ENERZINC untuk menjaga tubuh biar ga gampang lelah dan terus aktif!' },
        { name: 'og:type', content: 'website' },
        { name: 'og:image', content: '/img/enervon_active/botol-active.webp' },
        { name: 'robots', content: 'index, follow' },
        { name: 'googlebot', content: 'index, follow' },
      ],
    })

    useJsonld({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "Beranda",
                "item": `${url.origin}`
            },{
                "@type": "ListItem",
                "position": 2,
                "name": `Enervon Active`,
                "item": `${url.origin}/enervonactive`
            }]
    });

</script>